/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import ButtonOld from '@atlaskit/button';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import LegacyLockIcon from '@atlaskit/icon/glyph/lock-filled';
import Lozenge from '@atlaskit/lozenge';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Pressable } from '@atlaskit/primitives/compiled';
import { N500 } from '@atlaskit/theme/colors';
import { messages } from '../../../messages';
import { HoverCard } from '../../HoverCard';
import { ActionButton } from '../common/action-button';
import { Frame } from '../Frame';
import { IconAndTitleLayout, LozengeWrapper } from '../IconAndTitleLayout';
import { IconStyledButtonOldVisualRefresh } from '../styled';
import withFrameStyleControl from '../utils/withFrameStyleControl';
var styles = {
  iconWrapper: "_2hwx1i6y _1e0cbu77",
  actionButtonLozengeStyle: "_2rkogqwt _bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
};
var fallbackForbiddenIcon = function fallbackForbiddenIcon() {
  if (fg('platform-linking-visual-refresh-v1')) {
    return /*#__PURE__*/React.createElement(LockLockedIcon, {
      label: "error",
      color: "var(--ds-icon-danger, #C9372C)",
      LEGACY_fallbackIcon: LegacyLockIcon,
      LEGACY_size: "small",
      testId: "forbidden-view-fallback-icon"
    });
  }
  return /*#__PURE__*/React.createElement(Box, {
    as: "span",
    xcss: styles.iconWrapper
  }, /*#__PURE__*/React.createElement(LockLockedIcon, {
    label: "error",
    color: "var(--ds-icon-danger, #C9372C)",
    LEGACY_fallbackIcon: LegacyLockIcon,
    LEGACY_size: "small",
    testId: "forbidden-view-fallback-icon"
  }));
};
export var InlineCardForbiddenView = function InlineCardForbiddenView(_ref) {
  var url = _ref.url,
    icon = _ref.icon,
    onClick = _ref.onClick,
    isSelected = _ref.isSelected,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'inline-card-forbidden-view' : _ref$testId,
    truncateInline = _ref.truncateInline,
    requestAccessContext = _ref.requestAccessContext,
    onAuthorise = _ref.onAuthorise,
    context = _ref.context,
    showHoverPreview = _ref.showHoverPreview;
  var frameRef = React.useRef(null);
  var _React$useState = React.useState(!!(requestAccessContext !== null && requestAccessContext !== void 0 && requestAccessContext.callToActionMessageKey)),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    hasRequestAccessContextMessage = _React$useState2[0];
  var handleRetry = React.useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (onAuthorise) {
      onAuthorise();
    } else {
      var _requestAccessContext;
      requestAccessContext === null || requestAccessContext === void 0 || (_requestAccessContext = requestAccessContext.action) === null || _requestAccessContext === void 0 || _requestAccessContext.promise();
    }
  }, [onAuthorise, requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.action]);
  var renderForbiddenAccessMessage = React.useCallback(function () {
    if (requestAccessContext !== null && requestAccessContext !== void 0 && requestAccessContext.callToActionMessageKey) {
      var callToActionMessageKey = requestAccessContext.callToActionMessageKey;
      return /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages[callToActionMessageKey], {
        values: {
          product: context
        }
      }));
    }
    return /*#__PURE__*/React.createElement(FormattedMessage, messages.invalid_permissions, function (formattedMessage) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, formattedMessage);
    });
  }, [context, requestAccessContext]);
  var renderActionButton = React.useCallback(function () {
    var Button = withFrameStyleControl(ButtonOld, frameRef);
    var accessType = requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.accessType;
    if (hasRequestAccessContextMessage) {
      if (fg('platform-linking-visual-refresh-v1')) {
        var isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
        return /*#__PURE__*/React.createElement(ActionButton, {
          isDisabled: isDisabled,
          onClick: handleRetry,
          testId: "button-connect-other-account"
        }, renderForbiddenAccessMessage());
      }
      return /*#__PURE__*/React.createElement(Button, {
        spacing: "none",
        onClick: handleRetry,
        component: IconStyledButtonOldVisualRefresh,
        testId: "button-connect-other-account",
        role: "button",
        isDisabled: accessType === 'PENDING_REQUEST_EXISTS'
      }, renderForbiddenAccessMessage());
    }
    if (onAuthorise) {
      if (fg('platform-linking-visual-refresh-v1')) {
        return /*#__PURE__*/React.createElement(LozengeWrapper, null, /*#__PURE__*/React.createElement(Pressable, {
          xcss: styles.actionButtonLozengeStyle,
          onClick: handleRetry,
          testId: "button-connect-other-account"
        }, /*#__PURE__*/React.createElement(Lozenge, _extends({
          appearance: "moved"
        }, fg('platform-component-visual-refresh') ? {
          isBold: true
        } : undefined), renderForbiddenAccessMessage())));
      }
      return /*#__PURE__*/React.createElement(Button, {
        spacing: "none",
        onClick: handleRetry,
        appearance: "subtle-link",
        testId: "button-connect-other-account",
        role: "button"
      }, /*#__PURE__*/React.createElement(LozengeWrapper, null, /*#__PURE__*/React.createElement(Lozenge, _extends({
        appearance: 'moved'
      }, fg('platform-component-visual-refresh') ? {
        isBold: true
      } : undefined), renderForbiddenAccessMessage())));
    }
    return null;
  }, [handleRetry, hasRequestAccessContextMessage, onAuthorise, renderForbiddenAccessMessage, requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.accessType]);
  var content = /*#__PURE__*/React.createElement(Frame, {
    testId: testId,
    isSelected: isSelected,
    ref: frameRef,
    truncateInline: truncateInline
  }, /*#__PURE__*/React.createElement(IconAndTitleLayout, {
    icon: icon ? icon : fallbackForbiddenIcon(),
    link: url,
    title: url,
    onClick: onClick,
    titleColor: "var(--ds-text-subtle, ".concat(N500, ")")
  }), renderActionButton());
  if (showHoverPreview) {
    return /*#__PURE__*/React.createElement(HoverCard, {
      url: url
    }, content);
  }
  return content;
};